import { Link } from "@tanstack/react-router"
import { DocumentFilter, SearchNormal1 } from "iconsax-reactjs"
import { parseAsString, useQueryState } from "nuqs"
import InfiniteScroll from "react-infinite-scroll-component"
import PullToRefresh from "react-simple-pull-to-refresh"

import { getCampaignExplore } from "@/api"
import { GoBack, HotIcon, LoadingSpinner } from "@/components/shared"
import { Button } from "@/components/ui"
import { CampaignItem, CampaignItemSkeleton } from "@/features/jobs/explore/components"
import { useInfiniteScrollQuery } from "@/modules/helpers/hooks"
import { sendHaptic } from "@/modules/helpers/utils"
import type { Campaign } from "@/modules/types"

const SearchHeader = () => (
  <div className="flex justify-between items-center gap-2 py-4">
    <Link
      to="/s/campaign"
      onClick={() => sendHaptic()}
      className="rounded-xl transition-all ease-in-out h-12 z-40 lg:w-[240px] flex-1 gap-2 items-center px-3 flex border border-gray-200 bg-white"
    >
      <SearchNormal1 size={20} className="text-primary-800" />
      <p className="text-xs font-normal text-gray-500">Tìm kiếm</p>
    </Link>
    <Button variant={"ghost"} className="rounded-xl bg-white w-12 h-12 border !p-0">
      <DocumentFilter size={40} className="text-primary-800" />
    </Button>
    {/* <Select value={type} onValueChange={onTypeChange}>
      <SelectTrigger className="w-[94px] text-xs">
        <SelectValue placeholder="Tất cả" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem className="text-xs" value={"ALL_CAMPAIGN"}>
          Tất cả
        </SelectItem>
        <SelectItem className="text-xs" value={ECampaignType.AFFILIATE}>
          Tiếp thị liên kết
        </SelectItem>
        <SelectItem className="text-xs" value={ECampaignType.COST_PER_VIEW}>
          Trả tiền thưởng
        </SelectItem>
        <SelectItem className="text-xs" value={ECampaignType.REVIEW_PRODUCT}>
          Review sản phẩm
        </SelectItem>
      </SelectContent>
    </Select> */}
  </div>
)

const CampaignsPage = () => {
  const [type] = useQueryState("type", parseAsString.withDefault("ALL_CAMPAIGN"))
  const { data, fetchNextPage, hasNextPage, isLoading, isFetchingNextPage, forceRefetch } =
    useInfiniteScrollQuery({
      queryKey: ["explore", type],
      queryFn: getCampaignExplore,
      params: {
        take: 50,
        filterBy: type
      }
    })

  const handleRefresh = async () => {
    await forceRefetch()
  }
  return (
    <div className="px-2 flex flex-col relative">
      <GoBack />
      <div className="px-2">
        <div className="flex items-center gap-1">
          <HotIcon />
          <span className="text-xl font-medium text-primary-800">Chiến dịch</span>{" "}
          <span className="text-xl font-medium text-red-500">HOT</span>
        </div>
        <span className="text-xs text-gray-500">
          Là chiến dịch đang thịnh hành và có lượt mua khủng
        </span>
      </div>
      <div className="z-10 gap-2 flex flex-col px-2">
        <SearchHeader />
      </div>
      <PullToRefresh
        onRefresh={handleRefresh}
        pullingContent={""}
        maxPullDownDistance={80}
        refreshingContent={<LoadingSpinner className="w-20 h-20" />}
      >
        <div className="flex-1 flex flex-col px-2" id="scrollable">
          {isLoading && (
            <div className="lg:w-3/4 grid-cols-2 md:grid-cols-3 lg:grid-cols-4 grid lg:mr-auto pb-10 gap-1 md:gap-3">
              <CampaignItemSkeleton />
              <CampaignItemSkeleton />
              <CampaignItemSkeleton />
              <CampaignItemSkeleton />
            </div>
          )}
          {!isLoading && !data?.list?.length && (
            <div className="h-[55vh] pt-14 flex justify-center items-start">
              <p className="text-xs text-gray-400">Không có chiến dịch nào.</p>
            </div>
          )}
          <InfiniteScroll
            dataLength={data?.list?.length || 0}
            next={() => !isFetchingNextPage && hasNextPage && fetchNextPage()}
            hasMore={hasNextPage}
            scrollableTarget="scrollable"
            loader={<LoadingSpinner className="w-20 h-20" />}
          >
            <div className="grid grid-cols-2 gap-2 pb-4">
              {data?.list?.map((item: Campaign) => (
                <CampaignItem key={item?.id} data={item} />
              ))}
            </div>
          </InfiniteScroll>
        </div>
      </PullToRefresh>
    </div>
  )
}

export default CampaignsPage
